import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, LinkData, TextInput } from '../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class CellIsolationSpecialConverter extends CmsConverterService<CellIsolationSpecialData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      leftSide: {
        backgroundImage: CmsConverterService.mapImage(formData.st_left_background_image, lazyLoad, altText),
        bottomHeadline: formData.st_left_bottom_headline ?? defaultTextInput,
        bottomLink: formData.st_left_bottom_link ?? defaultLinkData,
        bottomText: formData.st_left_bottom_text ?? defaultTextInput,
        headerHeadline: formData.st_left_header_headline ?? defaultTextInput,
        headerText: formData.st_left_header_text ?? defaultTextInput,
        topHeadline: formData.st_left_top_headline ?? defaultTextInput,
        topLink: formData.st_left_top_link ?? defaultLinkData,
        topText: formData.st_left_top_text ?? defaultTextInput
      },
      rightSide: {
        backgroundImage: CmsConverterService.mapImage(formData.st_right_background_image, lazyLoad, altText),
        bottomHeadline: formData.st_right_bottom_headline ?? defaultTextInput,
        bottomLink: formData.st_right_bottom_link ?? defaultLinkData,
        bottomText: formData.st_right_bottom_text ?? defaultTextInput,
        headerHeadline: formData.st_right_header_headline ?? defaultTextInput,
        headerText: formData.st_right_header_text ?? defaultTextInput,
        topHeadline: formData.st_right_top_headline ?? defaultTextInput,
        topLink: formData.st_right_top_link ?? defaultLinkData,
        topText: formData.st_right_top_text ?? defaultTextInput,
      },
      bottomDes: formData.st_bottom_descriptor ?? defaultTextInput,
      topDes: formData.st_top_descriptor ?? defaultTextInput
    }
  }
}

export const CELL_ISOLATION_SPECIAL_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CellIsolationSpecialData>>(
  'CellIsolationSpecialConverterToken')

export interface CellIsolationSpecialData extends ConvertedComponentData {
  leftSide: CellIsolationSpecialItemData;
  rightSide: CellIsolationSpecialItemData;
  bottomDes: TextInput;
  topDes: TextInput;
}

export interface CellIsolationSpecialItemData {
  backgroundImage: Image;
  bottomHeadline: TextInput;
  bottomLink: LinkData;
  bottomText: TextInput;
  headerHeadline: TextInput;
  headerText: TextInput;
  topHeadline: TextInput;
  topLink: LinkData;
  topText: TextInput;
}
